// extracted by mini-css-extract-plugin
export default {"icon":"TeamsTabs_icon__2uqyU","menu":"TeamsTabs_menu__1U0FF","item":"TeamsTabs_item__1Mxmo","selected":"TeamsTabs_selected__3oxwh"};